import React from "react";
import type { TwelveMonthExpenseInsightItem } from "../../../domain/entities/TwelveMonthExpenseInsightsEntity";

export type { TwelveMonthExpenseInsightItem };

export interface TwelveMonthExpenseInsightsPanelProps {
  rangeLabel: string;
  insights: TwelveMonthExpenseInsightItem[];
  loading?: boolean;
}

const barClass: Record<TwelveMonthExpenseInsightItem["accentColor"], string> = {
  success: "bg-[#4ade80]",
  warning: "bg-[#f87171]",
  neutral: "bg-neutral-500",
};

export function TwelveMonthExpenseInsightsPanel({
  rangeLabel,
  insights,
  loading = false,
}: TwelveMonthExpenseInsightsPanelProps) {
  if (loading) {
    return (
      <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col gap-6 self-stretch px-6 py-6">
        <div className="h-4 w-40 max-w-full shrink-0 animate-pulse rounded bg-neutral-200" />
        <div className="flex min-h-0 flex-1 flex-col gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="min-h-0 flex-1 animate-pulse rounded bg-neutral-100"
            />
          ))}
        </div>
      </div>
    );
  }

  const headerLabel = rangeLabel ? `${rangeLabel} · Insights` : "Insights";
  const displayInsights = insights.slice(0, 3);

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col gap-6 self-stretch px-6 py-6">
      <span className="w-full shrink-0 text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-wider">
        {headerLabel}
      </span>
      <div className="flex min-h-0 w-full flex-1 flex-col gap-6">
        {displayInsights.map((item, i) => (
          <div
            key={i}
            className="flex min-h-0 w-full flex-1 flex-col justify-center"
          >
            <div className="flex w-full gap-4 items-stretch">
              <div
                className={`flex w-1 flex-none self-stretch rounded-full ${barClass[item.accentColor]}`}
              />
              <span className="text-body font-body text-pretty text-neutral-700 flex-1">
                {item.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
